import { InsightsFiltersOptionsQuery } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

export const useWorkplaceOptions = (filtersOptionsData: InsightsFiltersOptionsQuery) => {
  const options = useUnsafeMemo(
    () =>
      orderBy(
        filtersOptionsData.locations.locationsConnection.nodes,
        ['main', 'name'],
        ['desc', 'asc']
      ).map((workplace) => ({
        label: workplace.name,
        value: workplace.id,
      })),
    [filtersOptionsData]
  )

  return options
}
